"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerOperationResult = void 0;
/**
 * triggers FPIT tracking on success or failure of operation
 */
function triggerOperationResult(operation_type, status, errorDescription) {
    if (operation_type) {
        if (window && window.PAYPAL && window.PAYPAL.fpti) {
            setTimeout(function () {
                window.PAYPAL.fpti.triggerOperationResult(operation_type, status, errorDescription);
            }, 200);
        }
    }
    return "";
}
exports.triggerOperationResult = triggerOperationResult;
